import { render, staticRenderFns } from "./releaseNewsDetail.vue?vue&type=template&id=8adad2dc&scoped=true&"
import script from "./releaseNewsDetail.vue?vue&type=script&lang=js&"
export * from "./releaseNewsDetail.vue?vue&type=script&lang=js&"
import style0 from "./releaseNewsDetail.vue?vue&type=style&index=0&id=8adad2dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8adad2dc",
  null
  
)

export default component.exports